// Vtiger is retired: historic provenance stays stored, but is shown as a neutral "Legacy import" label.
export const sourceLabel = (s) => (/vtiger/i.test(String(s || "")) ? "Legacy import" : s);
